import React from "react";
import Layout from "../../components/layout";

const Viewopeninvoices = () => {
  return <>Viewopeninvoices</>;
};

export default Viewopeninvoices;
